<div class="row pb-3">
  <div class="col-12">
    <h1>You have been upgraded!</h1>
  </div>
</div>
